module.exports = __webpack_public_path__ + "static/countryside-2936d26788d427042dde266daa2b9422.jpg";